import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndexadoresPesquisaComponent } from './pesquisa/indexadores-pesquisa.component';
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';

const routes: Routes = [
  {
    path: 'indexadores/pesquisa',
    component: IndexadoresPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndexadoresRoutingModule { }
